module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-15-3e2eb047eff2f3fdbbd817059c8cc546.jpeg";